import { Component, ReactNode } from "react";
import { StorageRouterProps } from "../StorageRouterProps";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { StorageLayout } from "../StorageLayout";
import { StorageEntities } from "../StorageEntities";

export interface AssignmentViewPageProps extends NSARouterMakerResult, StorageRouterProps { }

class AssignmentViewPage extends Component<AssignmentViewPageProps>
{
    override render(): ReactNode
    {
        return (
            <StorageLayout
                {...this.props}
                pages={{
                    entity: StorageEntities.assignment(this.props),
                    view: {}
                }}
            >
                <></>
            </StorageLayout>
        );
    }
}

export default AssignmentViewPage;